
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { format } from "date-fns";
import { useIsMobile } from "@/hooks/use-mobile";

interface DateSelectorProps {
  value: string;
  onChange: (date: string) => void;
}

export const DateSelector = ({ value, onChange }: DateSelectorProps) => {
  const isMobile = useIsMobile();
  
  const today = format(new Date(), "yyyy-MM-dd");
  
  return (
    <div className="space-y-1">
      <Label htmlFor="date" className={isMobile ? "text-xs" : ""}>Date</Label>
      <Input
        id="date"
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        max={today}
        className={isMobile ? "h-8 text-xs" : ""}
      />
    </div>
  );
};
